<template>
  <div>
    <div class="row row-equal">
      <div class="flex md12">
        <va-card :title="pageTitle">
          <div class="row align--center margin--top align-content--center">
            <div class="flex xs6 md2">
              <va-input
                :value="nomRe"
                :placeholder="$t('poissonnierTable.searchByName')"
                removable
                @input="searchNom"
              >
                <va-icon
                  name="fa fa-search"
                  slot="prepend"
                />
              </va-input>
            </div>
            <div class="flex xs6 md2">
              <va-input
                :value="cpRe"
                :placeholder="$t('poissonnierTable.searchByPostcode')"
                removable
                @input="searchPostcode"
              >
                <va-icon
                  name="fa fa-search"
                  slot="prepend"
                />
              </va-input>
            </div>

            <div class="flex md6">
              <div class="row row-inside align--center">
                <va-button-toggle
                  outline
                  small
                  color="info"
                  class="toggle-activite"
                  v-model="showape"
                  :options="optionsApe"
                />
                <va-button-toggle
                  outline
                  small
                  color="info"
                  class="toggle-activite"
                  v-model="showinactive"
                  :options="options"
                />
                <h5
                  class="selection-nb-title"
                  :style="{ color: this.$themes['info'] }"
                >
                  Sélectionnés : {{ filteredData.length }}
                </h5>
                <va-popover
                  message="Rafraichir"
                  placement="top"
                >
                  <va-button
                    class="selection-refresh"
                    flat
                    large
                    color="info"
                    icon="fa fa-refresh"
                    @click="loadList()"
                  />
                </va-popover>
              </div>
            </div>
            <div class="flex md1">
              <va-popover
                message="Affichage des dates de création"
                placement="top"
              >
                <va-toggle
                  v-model="created_view"
                  flat
                  small
                  color="info"
                  label="Créat."
                /></va-popover>
            </div>
            <div class="flex md1">
              <va-input
                class="centered"
                :value="perPage"
                :label="$t('tables.perPage')"
                @input="changePageNumber"
              ></va-input>
            </div>
          </div>
          <div
            v-if="loadingStatuts"
            class="d-flex justify--center spinner"
          >
            <div>
              <va-progress-circle indeterminate />
            </div>
          </div>

          <va-data-table
            class="va-table--hoverable va-table--stripped"
            :fields="fields"
            :data="filteredData"
            :no-data-label="$t('poissonnierTable.empty')"
            :per-page="parseInt(perPage)"
            @row-clicked="showEntreprise"
            clickable
          >
            <template
              slot="name"
              slot-scope="props"
            >
              <v-popover
                trigger="hover focus"
                placement="right"
                :delay="{
                  show: 300,
                  hide: 0,
                }"
              >
                <!-- This will be the popover target (for the events and position) -->
                <p v-bind:class="{
                    inactive: !props.rowData.isactive,
                    liquidation: props.rowData.liquidation,
                  }">
                  {{ props.rowData.nom }}
                </p>

                <!-- This will be the content of the popover -->
                <template slot="popover">
                  <div class="row row-inside">
                    <div class="flex md3">
                      <p>SIRET:</p>
                    </div>
                    <div class="flex md9">
                      <p>{{ formatSiret(props.rowData.siret) }}</p>
                    </div>
                    <div class="flex md3">
                      <p>Courriel:</p>
                    </div>
                    <div class="flex md9">
                      <a :href="'mailto: ' + props.rowData.email">
                        {{ props.rowData.email }}
                      </a>
                    </div>
                    <div class="flex md3">
                      <p>Portable:</p>
                    </div>
                    <div class="flex md9">
                      <p>{{ formatPhoneNumber(props.rowData.portable) }}</p>
                    </div>
                    <div class="flex md3">
                      <p>Téléphone :</p>
                    </div>
                    <div class="flex md9">
                      <p>{{ formatPhoneNumber(props.rowData.telephone) }}</p>
                    </div>
                    <div class="flex md3">
                      <p>Site internet:</p>
                    </div>
                    <div class="flex md9">
                      <a :href="props.rowData.site_internet">
                        {{ props.rowData.site_internet }}
                      </a>
                    </div>
                    <div class="flex md3">
                      <p>Forme juridique:</p>
                    </div>
                    <div class="flex md9">
                      <p>{{ props.rowData.name }}</p>
                    </div>
                  </div>

                  <!-- You can put other components too -->
                </template>
              </v-popover>
            </template>

            <template
              slot="adhesion"
              slot-scope="props"
            >
              <va-badge
                v-show="props.rowData.id_link"
                class="fullwidth"
                color="gray"
              >Entreprise liée</va-badge>
              <va-badge
                v-show="props.rowData.unpf_adhesion === 1"
                class="fullwidth"
                color="success"
              >UNPF</va-badge>
              <va-badge
                v-if="props.rowData.spef_adhesion === 1"
                class="fullwidth"
                color="success"
              >SPEF</va-badge>

              <va-badge
                v-show="props.rowData.unpf_adhesion === 2"
                class="fullwidth"
                color="success"
                outline
              >UNPF - expiré {{ props.rowData.unpf_date_fin }}</va-badge>
              <va-badge
                v-if="props.rowData.spef_adhesion === 2"
                class="fullwidth"
                color="success"
                outline
              >SPEF - expiré {{ props.rowData.spef_date_fin }}</va-badge>
              <va-badge
                v-if="props.rowData.adhesions_agromer"
                class="fullwidth"
                color="warning"
              >AGROMER</va-badge>
              <va-badge
                v-if="props.rowData.adhesions_opam"
                class="fullwidth"
                color="info"
              >OPAM</va-badge>
              <va-badge
                v-show="props.rowData.adhesions_scapp"
                class="fullwidth"
                color="danger"
              >SCAPP</va-badge>
              <va-badge
                v-show="props.rowData.adhesions_languedoc"
                class="fullwidth"
                color="dark"
              >Languedoc Roussillon</va-badge>
              <va-badge
                v-show="props.rowData.adhesions_vendee"
                class="fullwidth"
                color="dark"
              >Vendée</va-badge>
              <va-badge
                v-show="props.rowData.adhesions_sdep"
                class="fullwidth"
                color="dark"
              >S.D.E.P.</va-badge>
            </template>

            <template
              slot="ccn"
              slot-scope="props"
            >
              <p
                class="text-ccn text-cac"
                v-if="props.rowData.inconnue_base_cac"
              >
                {{ props.rowData.inconnue_base_cac ? "Inconnue base CAC" : "" }}
              </p>
              <p
                class="text-ccn text-poissonnerie"
                v-if="props.rowData.ispoissonnerie"
              >
                {{
                  props.rowData.ispoissonnerie && props.rowData.idccn !== 1
                  ? "Considéré comme poissonnerie"
                  : ""
                }}
              </p>
              <va-badge
                class="fullwidth"
                :color="props.rowData.ccn_color"
              >
                {{ props.rowData.ccn_display }}
              </va-badge>
              <p class="text--secondary small-text align-center fullwidth">
                {{ props.rowData.ccnMsg }}
              </p>
            </template>

            <template
              slot="verification"
              slot-scope="props"
            >
              <va-badge
                class="fullwidth"
                :color="props.rowData.verifColor"
              >
                {{ props.rowData.verifTxt }}
              </va-badge>
              <p class="text--secondary small-text align-center fullwidth">
                {{ props.rowData.verifMsg }}
              </p>
            </template>

            <template
              slot="actions"
              slot-scope="props"
            >
              <va-popover
                message="Société.com"
                placement="left"
              >
                <va-button
                  flat
                  small
                  color="primary"
                  icon="fa fa-book"
                  @click="showSocieteCom(props.rowData)"
                />
              </va-popover>
              <va-popover
                v-if="canDelete"
                message="Supprimer"
                placement="left"
              >
                <va-button
                  flat
                  small
                  color="primary"
                  icon="fa fa-trash"
                  @click="deleteFirm(props.rowData, 2)"
                />
              </va-popover>
            </template>
          </va-data-table>
          <div
            class="flex xs12 md1 offset--md11"
            v-if="canCreate"
          >
            <div class="row row-inside">
              <va-button
                class="create-button"
                @click="showEntreprise"
              >
                <va-icon
                  size="30px"
                  name="fa fa-plus"
                />
              </va-button>
            </div>
          </div>
        </va-card>
      </div>
    </div>
    <dashboard-fiche-entreprise
      v-model="showFicheEntreprise"
      :tableentreprise="tableentreprise"
      @update="updateEntreprise"
      @create="addEntreprise"
    />
    <va-modal
      class="modal"
      title="Suppression d'entreprise"
      v-model="showConfirmDelete"
      :message="deleteModalMessage"
      cancelClass="none"
      okText="Supprimer"
      cancelText="Annuler"
      max-width="100%"
      v-on:ok="deleteFirm(entrepriseToDelete, 1)"
      v-on:cancel="deleteFirm(null, 0)"
    />
  </div>
</template>

<script>
import axios from "axios";
import { cloneDeep, debounce, findIndex, deburr } from "lodash";
import DashboardFicheEntreprise from "./DashboardFicheEntreprise";
import { mapGetters } from "vuex";
import moment from "moment";

export default {
  components: {
    DashboardFicheEntreprise
  },
  props: ["ccn", "codeape", "verif", "liquidation"],
  data() {
    return {
      created_view: false,
      canCreate: this.$store.getters.user.creation_entreprise,
      loadingStatuts: true,
      dateCompare: new Date(),
      entrepriseToDelete: null,
      deleteModalMessage: "Supprimer l'entreprise?",
      showConfirmDelete: false,
      canDelete: this.$store.getters.user.suppression_entreprises,
      options: [
        { label: "Actives", value: "active" },
        { label: "Toutes", value: "all" },
        { label: "Inactives", value: "inactive" }
      ],
      showinactive: "active",
      optionsApe: [
        { label: "Toutes", value: "all" },
        { label: "Boutiques", value: "4723Z" },
        { label: "Marchés", value: "4781Z" },
        { label: "Grossiste", value: "4638A" }
      ],
      showape: "all",
      tableentreprise: "",
      modalWidth: "100%",
      show: true,
      showFicheEntreprise: false,
      isaction: false,
      nomRe: null,
      cpRe: null,
      villeRe: null,
      dataEntreprises: [],
      perPage: "6"
    };
  },
  computed: {
    ...mapGetters(["loadEntreprise"]),
    pageTitle() {
      if (this.ccn && this.ccn === "ccn") {
        return "CCN";
      }
      if (this.ccn && this.ccn === "hors-ccn") {
        return "Entreprises hors CCN";
      }
      if (this.ccn && this.ccn === "ccn-inconnue") {
        return "Sans CCN identifiée";
      }

      if (this.verif && this.verif === "expiree") {
        return "Vérification expirée";
      }
      if (this.liquidation && this.liquidation === "liquidation") {
        return "Entreprise en liquidation";
      }

      return "Toutes entreprises";
    },
    fields() {

      let fields_array = [
        {
          name: "__slot:name",
          title: this.$t("poissonnierTable.headings.enseigne"),
          sortField: "nom",
          width: "15%"
        },

        {
          name: "code_postal",
          title: this.$t("poissonnierTable.headings.code_postal"),
          sortField: "code_postal",
          dataClass: "smaller-table-text",
          width: "5%"
        },
        {
          name: "ville",
          title: this.$t("poissonnierTable.headings.ville"),
          sortField: "ville",
          dataClass: "smaller-table-text",
          width: "8%"
        },
        {
          name: "contact_name",
          title: "Gérant",
          sortField: "contact_name",
          dataClass: "smaller-table-text",
          width: "10%"
        },
        {
          name: "__slot:adhesion",
          title: this.$t("poissonnierTable.headings.adhesion"),
          sortField: "nadhesion",
          width: "10%"
        }

      ]

      if (this.created_view) {
        fields_array.push({
          name: "creation_date_disp",
          title: "Création entreprise",
          sortField: "creation_date",
          dataClass: "smaller-table-text",
          width: "5%"
        })
        fields_array.push({
          name: "date_creation_base_disp",
          title: "Entrée annuaire",
          sortField: "date_creation_base",
          dataClass: "smaller-table-text",
          width: "5%"
        })
      } else {
        fields_array.push(
          {
            name: "__slot:journal",
            title: "Journal",
            sortField: "njournal",
            width: "10%"
          }
        )

      }

      fields_array.push(

        {
          name: "__slot:ccn",
          title: "CCN",
          sortField: "nccn",
          width: "10%"
        },
        {
          name: "code_ape",
          title: "Code APE",
          sortField: "code_ape",
          dataClass: "align-center",
          width: "5%"
        },
        {
          name: "__slot:verification",
          title: "Vérification",
          sortField: "dateVerification",
          width: "10%"
        },
        {
          name: "__slot:actions",
          dataClass: "text-right",
          width: "5%"
        })
      return fields_array;
    },
    filteredData() {
      let filteredData = this.dataEntreprises;

      // add linked firm when filtering
      let linkList = [];
      let entId = [];

      filteredData = filteredData.filter(item => {
        let boolcond = true;

        if (this.codeape && !(item.code_ape === this.codeape)) {
          boolcond = false;
        }

        if (this.showape !== "all" && !(item.code_ape === this.showape)) {
          boolcond = false;
        }

        if (
          this.verif &&
          this.verif === "non-verifie" &&
          item.verifColor !== "danger"
        ) {
          boolcond = false;
        }

        if (
          this.verif &&
          this.verif === "expiree" &&
          item.verifColor !== "warning"
        ) {
          boolcond = false;
        }

        if (
          this.liquidation &&
          this.liquidation === "liquidation" &&
          !item.liquidation
        ) {
          boolcond = false;
        }

        if (this.ccn && this.ccn === "ccn") {
          boolcond = boolcond && (item.idccn === 1 || item.ispoissonnerie);
        } else if (this.ccn && this.ccn === "hors-ccn") {
          boolcond = boolcond && item.idccn > 1 && !item.ispoissonnerie;
        } else if (this.ccn && this.ccn === "ccn-inconnue") {
          boolcond = boolcond && !item.idccn && !item.ispoissonnerie;
        }

        if (this.showinactive === "active" && !item.isactive) {
          boolcond = false;
        }

        if (this.showinactive === "inactive" && item.isactive) {
          boolcond = false;
        }

        // account for linked firm that we want to appear when the main firm is looked up
        // still search based on active/inactive and other
        let boolcondsearch = true;

        if (this.nomRe && this.nomRe.length >= 1) {
          let nomCpre = deburr(this.nomRe).toLowerCase();
          boolcondsearch =
            boolcondsearch &&
            (deburr(item.nom)
              .toLowerCase()
              .includes(nomCpre) ||
              deburr(item.contact_name)
                .toLowerCase()
                .includes(nomCpre) ||
              (item.siret && item.siret.includes(nomCpre)) ||
              (item.telephone && item.telephone.includes(nomCpre)) ||
              (item.portable && item.portable.includes(nomCpre)) ||
              deburr(item.email)
                .toLowerCase()
                .includes(nomCpre));
        }

        if (this.cpRe && this.cpRe.length >= 1) {
          let cpCpre = deburr(this.cpRe).toLowerCase();
          boolcondsearch =
            boolcondsearch &&
            (item.code_postal.toLowerCase().startsWith(cpCpre) ||
              deburr(item.ville)
                .toLowerCase()
                .includes(cpCpre));
        }

        if (boolcondsearch) {
          entId.push(item.identreprise);
          if (item.id_link) {
            linkList.push(item.id_link);
          }
        }

        return boolcond;
      });

      filteredData = filteredData.filter(item => {
        if (
          entId.includes(item.identreprise) ||
          linkList.includes(item.id_link)
        ) {
          return true;
        } else {
          return false;
        }
      });

      return filteredData;
    }
  },
  mounted() {
    let pastYear = this.dateCompare.getFullYear() - 1;
    this.dateCompare.setFullYear(pastYear);
    this.loadList();
  },
  methods: {
    loadList() {
      this.loadingStatuts = true;
      axios.get("/api/entreprises-list").then(resp => {
        for (let value of resp.data) {
          value = this.transformEntrepriseDatas(value);
        }
        this.dataEntreprises = resp.data;
        this.loadingStatuts = false;
        //console.log("dataEntreprises", this.dataEntreprises);
      });
    },
    deleteFirm(entreprise, action) {
      this.isaction = true;
      //prepare and show modal
      if (action === 2) {
        this.deleteModalMessage =
          "Voulez vous supprimer : " +
          entreprise.nom +
          " et toutes les données associées?";
        this.entrepriseToDelete = cloneDeep(entreprise);
        this.showConfirmDelete = true;
      } else if (action === 0) {
        //annulation de la suppression
        this.entrepriseToDelete = null;
        this.showConfirmDelete = false;
      } else if (action === 1) {
        axios
          .delete("/api/entreprise", {
            data: { entreprise: this.entrepriseToDelete }
          })
          .then(res => {
            this.deleteEntrepriseFromTable(
              this.entrepriseToDelete.identreprise
            );
            this.launchEpicmaxToast("Entreprise supprimée");
          })
          .catch(err => {
            console.log(err);
            this.launchEpicmaxToast("Erreur lors de la suppression");
          });
      }
    },
    showSocieteCom(entreprise) {
      this.isaction = true;
      let url = "https://www.societe.com/cgi-bin/search?champs=";
      let search = entreprise.siret ? entreprise.siret : entreprise.nom;

      window.open(url + search, "_blank");
    },
    showEntreprise(entreprise) {
      if (!this.isaction) {
        this.showFicheEntreprise = true;
        this.tableentreprise = entreprise;
      }
      this.isaction = false;
    },
    searchNom: debounce(function (nomRe) {
      this.nomRe = nomRe;
    }, 400),
    changePageNumber: debounce(function (perPage) {
      var n = Math.floor(Number(perPage));
      if (n !== Infinity && String(n) === perPage && n >= 0) {
        this.perPage = perPage;
      } else {
        this.perPage = "6";
      }
    }, 400),
    searchVille: debounce(function (perPage) {
      this.villeRe = villeRe;
    }, 400),
    searchPostcode: debounce(function (cpRe) {
      this.cpRe = cpRe;
    }, 400),
    deleteEntrepriseFromTable(idEntreprise) {
      let i = findIndex(this.dataEntreprises, ["identreprise", idEntreprise]);
      //force detection update of the dataarray
      this.$delete(this.dataEntreprises, i);
    },
    async updateEntreprise(identreprise) {
      console.log("update");
      try {
        let res = await axios.get("/api/entreprise/infosList", {
          params: {
            identreprise: identreprise
          }
        });
        let value = this.transformEntrepriseDatas(res.data[0]);
        let i = findIndex(this.dataEntreprises, [
          "identreprise",
          value.identreprise
        ]);
        //force update on deep change
        ///need to clean the data received
        this.$set(this.dataEntreprises, i, value);
        this.$store.dispatch("udateStats");
      } catch (err) {
        console.log(err);
      }
    },
    addEntreprise(value) {
      value = this.transformEntrepriseDatas(value);

      this.dataEntreprises.push(value);
      this.$store.dispatch("udateStats");
    },
    launchEpicmaxToast(toast) {
      this.showToast(toast, {
        position: "bottom-center",
        duration: 5000
      });
    },

    transformEntrepriseDatas(value) {
      if (
        value.spef_adhesion ||
        value.unpf_adhesion ||
        value.adhesions_opam ||
        value.adhesions_agromer ||
        value.adhesions_scapp
      ) {
        value.nadhesion = "a";
      } else {
        value.nadhesion = "b";
      }
      if (value.jse_date_fin) {
        value.njournal = "a";
      } else if (value.jscstat) {
        value.njournal = "c";
      } else {
        value.njournal = "b";
      }

      value.nccn = value.nom_ccn ? value.nom_ccn : "z";
      if (value.idccn) {
        value.ccn_display = value.idcc
          ? value.idcc + " - " + value.nom_ccn
          : value.nom_ccn;
        // case poissonnerie
        if (value.idccn === 1 || value.ispoissonnerie === 1) {
          value.ccn_color = "success";
        } else if (value.idccn === 9) {
          value.ccn_color = "gray";
        } else {
          value.ccn_color = "#BF9000";
        }
      } else {
        value.ccn_display = "CCN inconnue";
        value.ccn_color = "danger";
      }

      value.ccnMsg = value.dateccn
        ? moment(value.dateccn, "YYYY-MM-DD").format("DD-MM-YYYY")
        : "";
      value.ccnMsg = value.usernameccn
        ? value.ccnMsg + " " + value.usernameccn
        : value.ccnMsg;

      value.code_postal = value.code_postal ? value.code_postal : "";
      value.ville = value.ville ? value.ville : "";
      value.contact_name = value.contact_name ? value.contact_name : "";
      value.code_ape = value.code ? value.code : "";

      if (value.latest_verification) {
        let t = value.latest_verification.split("-");
        let dateVerification = new Date(t[0], t[1] - 1, t[2]);
        value.dateVerification = value.latest_verification;
        value.verifMsg =
          t[2] + "-" + t[1] + "-" + t[0] + "  " + value.usernameverif;

        if (dateVerification > this.dateCompare) {
          // entreprise vérifiée dans l'année
          value.verifTxt = "Vérifié";
          value.verifColor = "success";
        } else {
          value.verifTxt = "A vérifier";
          value.verifColor = "warning";
        }
      } else {
        value.verifTxt = "Jamais vérifié";
        value.verifColor = "danger";
        value.dateVerification = "";
      }

      if (value.date_creation_base) {
        value.date_creation_base_disp = moment(value.date_creation_base).format("DD/MM/YYYY");
      } else {
        value.date_creation_base_disp = "";
        value.date_creation_base = "";
      }

      if (value.creation_date) {
        value.creation_date_disp = moment(value.creation_date).format("DD/MM/YYYY");
      } else {
        value.creation_date_disp = "";
        value.creation_date = "";
      }

      // if the firm is not currently adherent but was in the past, display if less than a year
      // changed to all time as per request from 4/12/2020

      if (!value.spef_adhesion && value.spef_date_fin) {
        // if (
        //   moment(value.spef_date_fin, "YYYY-MM-DD").isAfter(
        //     moment().subtract(100, "years")
        //   )
        // ) {
        //indicate that adhesion is expired
        value.spef_adhesion = 2;
        // get date fin adhesion in right display format
        value.spef_date_fin = moment(value.spef_date_fin).format("DD/MM/YYYY");
        // }
      }

      if (!value.unpf_adhesion && value.unpf_date_fin) {
        // if (
        //   moment(value.unpf_date_fin, "YYYY-MM-DD").isAfter(
        //     moment().subtract(1, "years")
        //   )
        // ) {
        //indicate that adhesion is expired
        value.unpf_adhesion = 2;
        // get date fin adhesion in right display format
        value.unpf_date_fin = moment(value.unpf_date_fin).format("DD/MM/YYYY");
        // }
      }

      return value;
    },
    formatPhoneNumber(str) {
      if (str) {
        let newStr =
          str.slice(0, 2) +
          " " +
          str.slice(2, 4) +
          " " +
          str.slice(4, 6) +
          " " +
          str.slice(6, 8) +
          " " +
          str.slice(8, 10);
        return newStr;
      }
      return str;
    },
    formatSiret(siret) {
      if (!siret) {
        return null;
      }
      siret = this.removeWhiteSpace(siret);

      // 3 3 3 puis 5

      return (
        siret.slice(0, 3) +
        " " +
        siret.slice(3, 6) +
        " " +
        siret.slice(6, 9) +
        " " +
        siret.slice(9, 14)
      );
    },
    removeWhiteSpace(str) {
      if (str) return str.replace(/ /g, "");
      return null;
    }
  },
  watch: {
    ccn(newvalue) {
      this.$store.commit("setTestVal", "test45");
    },
    loadEntreprise(newid) {
      if (newid) {
        let i = findIndex(this.dataEntreprises, ["identreprise", newid]);
        this.showEntreprise(this.dataEntreprises[i]);
        this.$store.commit("setLoadEntreprise", false);
      }
    }
  }
};
</script>

<style lang="scss">
.smaller-table-text {
  font-size: 0.8em;
}

.centered input {
  text-align: center;
}

.create-button {
  position: relative;
}

.toggle-activite {
  position: relative;
  top: -0.5em;
}

.align-center {
  text-align: center;
}

.spinner {
  top: 50%;
  left: 50%;
}

.selection-nb-title {
  position: relative;
  top: -0.5em;
  margin-left: 0.5em;
}

.selection-refresh {
  position: relative;
  top: -0.4em;
}

.tooltip {
  display: block !important;
  z-index: 10000;
  padding-left: 16px;
}

.tooltip .tooltip-inner {
  background: black;
  width: 700px;
  overflow: hidden;
  color: white;
  border-radius: 16px;
  padding: 5px 10px 4px;
}

.tooltip .tooltip-arrow {
  padding-left: 16px;
  width: 0;
  height: 0;
  border-style: solid;
  position: absolute;
  margin: 5px;
  border-color: black;
  z-index: 1;
}

.tooltip[x-placement^="top"] {
  margin-bottom: 5px;
}

.tooltip[x-placement^="top"] .tooltip-arrow {
  border-width: 5px 5px 0 5px;
  border-left-color: transparent !important;
  border-right-color: transparent !important;
  border-bottom-color: transparent !important;
  bottom: -5px;
  left: calc(50% - 5px);
  margin-top: 0;
  margin-bottom: 0;
}

.tooltip[x-placement^="bottom"] {
  margin-top: 5px;
}

.tooltip[x-placement^="bottom"] .tooltip-arrow {
  border-width: 0 5px 5px 5px;
  border-left-color: transparent !important;
  border-right-color: transparent !important;
  border-top-color: transparent !important;
  top: -5px;
  left: calc(50% - 5px);
  margin-top: 0;
  margin-bottom: 0;
}

.tooltip[x-placement^="right"] {
  margin-left: 5px;
}

.tooltip[x-placement^="right"] .tooltip-arrow {
  border-width: 5px 5px 5px 0;
  border-left-color: transparent !important;
  border-top-color: transparent !important;
  border-bottom-color: transparent !important;
  left: -5px;
  top: calc(50% - 5px);
  margin-left: 0;
  margin-right: 0;
}

.tooltip[x-placement^="left"] {
  margin-right: 5px;
}

.tooltip[x-placement^="left"] .tooltip-arrow {
  border-width: 5px 0 5px 5px;
  border-top-color: transparent !important;
  border-right-color: transparent !important;
  border-bottom-color: transparent !important;
  right: -5px;
  top: calc(50% - 5px);
  margin-left: 0;
  margin-right: 0;
}

.tooltip.popover .popover-inner {
  background: #f9f9f9;
  color: black;
  padding: 24px;
  border-radius: 5px;
  box-shadow: 0 5px 30px rgba(black, 0.1);
}

.tooltip.popover .popover-arrow {
  border-color: #f9f9f9;
}

.tooltip[aria-hidden="true"] {
  visibility: hidden;
  opacity: 0;
  transition: opacity 0.15s, visibility 0.15s;
}

.tooltip[aria-hidden="false"] {
  visibility: visible;
  opacity: 1;
  transition: opacity 0.15s;
}

.tooltip:hover {
  pointer-events: auto;
}

.margin--top {
  padding-top: 5px;
}

.text-ccn {
  font-size: 0.8em;
  font-weight: bold;
}

.text-poissonnerie {
  color: #4ae387;
}

.inactive {
  color: red;
}

.liquidation {
  color: orange;
}
</style>
